var portfolioPositionsList = {
	caption: "Posiciones del portafolio",
	name: "Nombre",
	isin: "ISIN",
	numberOfShares: "Cantidad/Nominal",
	price: "Precio",
	dateTime: "Fecha/Hora",
	todayChange: "Cambios hoy",
	unrealizedPerformance: "Rendimiento no realizado",
	marketValue: "Valor de mercado",
	purchaseValue: "Valor de la compra",
	weight: "Peso %",
	actions: "Acciones",
	noPositions: "Sin posiciones.",
	averagePurchasePrice: "Precio promedio  de compra"
};
var es = {
	portfolioPositionsList: portfolioPositionsList
};

export { es as default, portfolioPositionsList };
